import { z } from 'zod';
/**
 * Token de desenvolvimento: `dev.` seguido do JSON da identidade em
 * base64url. Não tem assinatura de propósito, para ninguém confundi-lo com
 * segurança. O backend só o aceita com `AUTH_MODE=dev`, que o boot recusa em
 * produção.
 */
export const DEV_TOKEN_PREFIX = 'dev.';
export const devIdentitySchema = z.discriminatedUnion('kind', [
    z.strictObject({
        kind: z.literal('user'),
        email: z.email(),
        name: z.string().min(1),
    }),
    z.strictObject({
        kind: z.literal('app'),
        appId: z.string().min(1),
        /** Equivalem aos app roles de um token real: chaves de permissão. */
        roles: z.array(z.string()),
    }),
]);
//# sourceMappingURL=dev-token.contract.js.map